export class AuthenticationError<M> extends Error {
  constructor(
    message: string,
    public readonly meta?: M,
  ) {
    super('[Authentication error]: ' + message);
    this.name = 'AuthenticationError';
  }
}
